import React from "react";

const RemoveAspectModal = ({ open, onClose, onConfirm, loading, deleted }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className="bg-white rounded-[16px] shadow-xl p-7 w-full max-w-[500px] mx-4 flex flex-col items-center text-center">
        {/* Title */}
        <h2 className="text-[18px] font-semibold text-[#18181B] font-outfit mb-2">
          Remove custom aspect?
        </h2>

        {/* Description */}
        <p className="text-[14px] text-[#71717A] font-medium font-outfit leading-relaxed mb-7">
          This will remove the selected aspect from scoring configuration and
          may impact scoring outcomes
        </p>

        {/* Buttons */}
        <div className="flex items-center gap-4 w-full justify-center">
          <button
            onClick={onClose}
            disabled={loading || deleted}
            className="w-[30%] py-[10px] px-2 rounded-[8px] border border-[#C95EBE] text-[#C95EBE] text-[14px] font-medium font-outfit hover:bg-[#C95EBE] hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={loading || deleted}
            className="w-[45%] py-[10px] rounded-[8px] border border-[#00000033] text-[#52525B] text-[14px] font-medium font-outfit hover:bg-[#E21919] hover:border-none hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {deleted ? "Deleted" : loading ? "Deleting..." : "Remove Aspect"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveAspectModal;
